import ShoppingCart from '../client/pages/shoppingcart/pages/bag'
import Checkout from '../client/pages/shoppingcart/pages/checkout'
import CreditPage from '../client/pages/shoppingcart/pages/credit-pay'
import CollectProducts from '../client/pages/shoppingcart/pages/collect-order'
import FreeGifts from '../client/pages/shoppingcart/pages/collect-order/pages/free-gfits'
import Unpaid from '../client/pages/shoppingcart/pages/unpaid'
import FbCheckoutUrl from '../client/pages/shoppingcart/pages/fb-checkout-url'
import StripeKlarnaSuccess from '../client/pages/shoppingcart/components/stripe-klarna-button/success'

export default [
    {
        path: "/cart/",
        exact: true,
        component: ShoppingCart,
        page: 'shoppingcart',
        cn_page: '购物车页',
        title: {
            'en': 'Shopping Bag'
        },
        description: {
            'en': 'Shopping Bag'
        }
    },
    {
        path: "/cart/collect-products",
        exact: true,
        component: CollectProducts,
        page: 'collect products',
        cn_page: '凑单页',
        title: {
            'en': 'Collect Products'
        },
        description: {
            'en': 'Collect Products'
        }
    },
    {
        path: "/cart/free-gifts",
        exact: true,
        component: FreeGifts,
        page: 'Free Gifts',
        cn_page: '礼物挑选页',
        title: {
            'en': 'Free Gifts'
        },
        description: {
            'en': 'Free Gifts'
        }
    },
    {
        path: "/cart/checkout",
        exact: true,
        component: Checkout,
        page: 'checkout',
        cn_page: '下单页',
        title: {
            'en': 'Order Confirmation'
        },
        description: {
            'en': 'Order Confirmation'
        }
    },
    {
        path: "/cart/credit-card/:orderId",
        component: CreditPage,
        page: 'credit card',
        cn_page: '信用卡页面',
        title: {
            'en': 'Credit Card / Debit Card'
        },
        description: {
            'en': 'Credit Card / Debit Card'
        }
    },
    {
        path: "/checkout/:orderId",
        component: Unpaid,
        page: 'unpaid order',
        cn_page: '未付款订单',
        title: {
            'en': 'unpaid order'
        },
        description: {
            'en': 'unpaid order'
        }
    },
    {
        path: "/fb-checkout-url",
        component: FbCheckoutUrl,
        page: 'fb checkout',
        cn_page: 'fb checkout',
        title: {
            'en': 'fb checkout'
        },
        description: {
            'en': 'fb checkout'
        }
    },
    {
        path: "/cart/stripe-klarna-success",
        component: StripeKlarnaSuccess,
        page: 'success',
        cn_page: 'success',
        title: {
            'en': 'success'
        },
        description: {
            'en': 'success'
        }
    }
]